/* eslint-disable react/destructuring-assignment */
import { Group } from '@mantine/core';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityDocumentFileType } from '../../../../../../../models/core/entities.type';

type DataViewActionProps = {
  item: EntityDocumentFileType;
  confirmActionResult(items: EntityDocumentFileType[] | null, action: string, confirmed: boolean): void;
  // eslint-disable-next-line react/no-unused-prop-types
  zIndex: number;
};

export default function DocumentFileFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o arquivo."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult([props.item], 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult([props.item], 'excluir', false);
        }}
      />
    </Group>
  );
}
